import styled from 'styled-components';

export const SBody = styled.div`
  margin-left: 85px;

  display: flex;
  flex-direction: column;
`;

interface IMessagesProps {
  expanded: boolean;
}

export const SWrapper = styled.div<IMessagesProps>`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 95px);
  margin-right: 20px;
  min-width: 750px;

  ${({ expanded }) =>
    expanded &&
    `
      display: contents;
    `}
`;

export const SMessages = styled.div<IMessagesProps>`
  display: flex;
  flex: 0 1 100%;
  margin-left: -20px;
  margin-right: -20px;
  margin-top: 20px;
  max-width: calc(100vw - 65px);
  min-height: 0;
  min-width: calc(100% + 20px);

  ${({ expanded, theme }) =>
    expanded &&
    `
      background-color: ${theme.colors.primaryBackground};
      height: calc(100vh - 5px);
      left: 65px;
      margin: 0;
      min-width: 770px;
      position: absolute;
    `}
`;

interface IHideFiltersProps {
  visible: boolean;
}

export const SHideFilters = styled.i<IHideFiltersProps>`
  display: none;
  width: 0;
  height: 0;

  color: ${({ theme }) => theme.colors.tertiaryText};
  cursor: pointer;
  z-index: 1;

  ${({ visible }) => {
    if (!visible) {
      return `
        display: block;
        position: absolute;
        bottom: calc(100vh / 2);`;
    }
  }}
`;

interface IFilterListWrapperProps {
  visible: boolean;
}

export const SFilterListWrapper = styled.div<IFilterListWrapperProps>`
  display: flex;

  &:hover ${SHideFilters} {
    ${({ visible }) => {
      if (visible) {
        return `
        display: block;
        position: relative;
        right: 24px;
        top: 5px;`;
      }
    }}
  }
`;

interface IFilterListProps {
  visible: boolean;
}

export const SFilterList = styled.div<IFilterListProps>`
  display: flex;
  flex-direction: column;

  ${({ visible }) =>
    !visible &&
    `
        display: none !important;
        flex-direction: column !important;`}
`;

export const SExpandList = styled.div`
  display: none;
`;

export const SMessageListDiv = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  overflow: hidden;

  &:hover ${SExpandList} {
    color: ${({ theme }) => theme.colors.tertiaryText};
    cursor: pointer;
    display: block;
    height: 0;
    position: relative;
    right: -14px;
    top: 5px;
    width: 0;
    z-index: 1;
  }
`;
